import ApiCalling from "../../ApiServices/ApiCalling";
import { useState, useEffect } from "react";
import AuthInfoObj from "../../ApiServices/AuthInfoObj.js";
import { APPID, DOMAIN_NAME, VERSION, REFERER } from "../../Config.js";
import { toast } from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";

const MobilePrepaidService = (serviceID) => {
  const isLoggedIn =
    sessionStorage.getItem("session") && sessionStorage.getItem("sessionID");
  const navigate = useNavigate();
  const [input, setInput] = useState({});

  const [getHlrLookupData, setHlrLookupData] = useState({
    operator: "",
    circle: "",
    oid: "",
    circleID: "",
  });
  const [getRechargePlanData, setRechargePlanData] = useState();
  const [selectedAmount, setSelectedAmount] = useState("");
  const [oid, setOID] = useState();
  const [showPopup, setShowPopup] = useState(false);
  const [getBalanceData, setBalanceData] = useState({});
  const [getDiscountAmtData, setDiscountAmtData] = useState({});
  const [successPopup, setSuccessPopup] = useState(false);
  const [getPaymentTransaction, setPaymentTransaction] = useState();
  const [getTransactionStatus, setTransactionStatus] = useState({});
  const [getPaymentModeData, setGetPaymentModeData] = useState([]);
  const [addMoneyPopup, setAddMoneyPopup] = useState(false);
  const [paymentGatewayData, setPaymentGatewayData] = useState({});
  const [searchTerm, setSearchTerm] = useState("");
  const [amountError, setAmountError] = useState("");
  const [isRechargeProcess, setGetRechargeProcess] = useState(false);
  const location = useLocation();
  // existing states ke neeche ye 2 add karo
  const [getFilteredList, setFilteredList] = useState([]);

  // existing useEffects ke saath ye add karo
  useEffect(() => {
    if (serviceID) {
      getNumberList(serviceID);
    }
  }, [serviceID]);

  const PG_TYPES = {
    PAYTM: 1,
    RZRPAY: 2,
    ICICIUPI: 3,
    AGRPAY: 4,
    UPIGATEWAY: 5,
    PAYU: 6,
    PAYTMJS: 7,
    CASHFREE: 8,
    CASHFREEDEMOTEST: 9,
    UPIGATEWAYNEW: 10,
    MITRAGATEWAY: 11,
    ALLUPI: 12,
    PHONEPE: 18,
    USDTGATEWAY: 19,
  };

  useEffect(() => {
    if (input?.Mobile && input?.Mobile?.length === 10) {
      getHLRLookUp();
    }
  }, [input?.Mobile]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (/^\d{0,10}$/.test(value)) {
      setInput((prev) => ({ ...prev, [name]: value }));
    }
  };

  const getNumberList = async (serviceID) => {
    try {
      const res = await ApiCalling.request(
        "POST",
        "/GetNumberList",
        null,
        null,
      );
      if (res?.statuscode === 1) {
        const allOperators = res.data?.operators || [];
        const filtered = allOperators.filter(
          (item) => item.opType === serviceID,
        );
        const formatted = filtered.map((item) => ({
          oid: item.oid,
          label: item.name,
          image: item.image,
        }));
        setFilteredList(formatted);
      } else {
        console.error(res?.msg);
      }
    } catch (err) {
      console.error("Error getNumberList:", err);
    }
  };

  const getHLRLookUp = async (e) => {
    try {
      const bodyObject = {
        Mobile: input?.Mobile,
      };

      const res = await ApiCalling.request(
        "POST",
        "/CheckNumberSeries",
        bodyObject,
        null,
      );
      if (res?.statuscode === 1) {
        const hlrData = {
          operator: res?.hlrResponce.operator || "",
          circle: res?.hlrResponce.circle || "",
          oid: res?.hlrResponce.oid || "",
          circleID: res?.hlrResponce.circleID || "",
          mobileNo: res?.mobileNo || "",
          min: res?.hlrResponce.min,
          max: res?.hlrResponce.max,
        };
        setHlrLookupData(hlrData);
        setOID(hlrData.oid);
        if (hlrData.oid && hlrData.circleID) {
          rechargeSimplePlan(hlrData.oid, hlrData.circleID);
        }
      } else {
        console.error(res?.msg, { toastId: "getHLRLookUp error" });
      }
    } catch (error) {
      console.error("Error getHLRLookUp :", error);
    }
  };

  const rechargeSimplePlan = async (oid, circleID) => {
    try {
      const bodyObject = {
        OID: oid,
        CircleID: circleID,
        AccountNo: input?.Mobile,
      };

      const res = await ApiCalling.request(
        "POST",
        "/GetPlanRoffer",
        bodyObject,
        null,
      );

      if (res?.statuscode === 1) {
        setRechargePlanData(res.data.types);
      } else {
        console.error(res?.msg);
      }
    } catch (error) {
      console.error("Error GetPlanRoffer :", error);
    }
  };

  const handleRechargeClick = async () => {
    const minAmount = parseFloat(getHlrLookupData?.min);
    const maxAmount = parseFloat(getHlrLookupData?.max);
    const enteredAmount = parseFloat(selectedAmount);

    setAmountError("");

    if (!input?.Mobile?.trim()) {
      toast.error("Please enter a valid mobile number");
      return;
    }

    if (!selectedAmount?.trim()) {
      toast.error("Please enter recharge amount");
      return;
    }

    if (
      isNaN(enteredAmount) ||
      enteredAmount < minAmount ||
      enteredAmount > maxAmount
    ) {
      setAmountError(`Amount must be between ₹${minAmount} and ₹${maxAmount}`);
      return;
    }

    if (!isLoggedIn) {
      sessionStorage.setItem(
        "pendingRecharge",
        JSON.stringify({ mobile: input?.Mobile, amount: selectedAmount }),
      );
      return navigate("/loginOtp");
    }
    setGetRechargeProcess(true);
    sessionStorage.setItem(
      "pgRedirectedFrom",
      JSON.stringify({
        path: location.pathname,
        mobile: input?.Mobile,
        amount: selectedAmount,
        oid: getHlrLookupData.oid,
      }),
    );

    try {
      await rechargeDiscountOffer(selectedAmount);
      await getBalanceUser();
      setShowPopup(true);
    } catch (error) {
      console.error("Recharge process failed", error);
    } finally {
      setGetRechargeProcess(false);
    }
  };

  const getBalanceUser = async () => {
    try {
      const res = await ApiCalling.apiClient.request({
        method: "POST",
        url: "/GetBalance",
        data: {},
        headers: {
          appID: APPID,
          version: VERSION,
          domain: DOMAIN_NAME,
          userID: AuthInfoObj().userID,
          sessionID: AuthInfoObj().sessionID,
          session: AuthInfoObj().session,
        },
      });

      if (res?.statuscode === 1) {
        setBalanceData(res?.data);
      } else {
        console.error(res?.msg);
      }
    } catch (error) {
      console.error("Error getBalanceUser :", error);
    }
  };

  const rechargeDiscountOffer = async (amount, customOid = oid) => {
    try {
      const res = await ApiCalling.apiClient.request({
        method: "POST",
        url: "/GetCommissionAmount",
        data: {
          ID: 0,
          amount: amount,
          appid: APPID,
          imei: "",
          loginTypeID: 1,
          oid: customOid,
          paymentID: 0,
          regKey: "",
          serialNo: "",
          session: AuthInfoObj().session,
          sessionID: AuthInfoObj().sessionID,
          userID: AuthInfoObj().userID,
          version: VERSION,
          Account: input?.Mobile,
        },

        headers: {
          "Content-Type": "application/json",
        },
      });
      if (res?.statuscode === 1) {
        setDiscountAmtData(res?.cashBackResp);
      } else {
        console.error(res?.msg);
      }
    } catch (error) {
      console.error("Error in rechargeDiscountOffer:", error);
    }
  };

  const paymentTransaction = async (amount, oid, mobileNo) => {
    navigator.geolocation.getCurrentPosition(
      async (position) => {
        const latitude = position.coords.latitude;
        const longitude = position.coords.longitude;
        const geoCode = `${latitude},${longitude}`;

        try {
          const res = await ApiCalling.apiClient.request({
            method: "POST",
            url: "/Transaction",
            data: {
              loginTypeID: 1,
              oid: oid,
              accountNo: mobileNo,
              amount: amount,
              geoCode: geoCode,
              customerNo: "",
              imei: "",
              regKey: "",
              serialNo: "",
              o1: "",
              o2: "",
              o3: "",
              o4: "",
              fetchBilID: 0,
              isReal: false,
              refID: "",
              securityKey: "",
            },
            headers: {
              "Content-Type": "application/json",
              appid: APPID,
              version: VERSION,
              session: AuthInfoObj().session,
              sessionID: AuthInfoObj().sessionID,
              userID: AuthInfoObj().userID,
            },
          });

          if (res?.statuscode === 1) {
            setTransactionStatus({ statuscode: res?.statuscode });
          } else if (res?.statuscode === 2) {
            setTransactionStatus({ statuscode: res?.statuscode });
          } else if (res?.statuscode === 3) {
            setTransactionStatus({ statuscode: res?.statuscode });
          } else {
            console.error(res?.msg);
          }
          setPaymentTransaction(res);
          setShowPopup(false);
          setSuccessPopup(true);
        } catch (error) {
          console.error("Error in paymentTransaction:", error);
        }
      },
      (error) => {
        console.error("Failed to fetch geolocation:", error);
      },
    );
  };

  const getPaymentMode = async () => {
    try {
      const res = await ApiCalling.apiClient.request({
        method: "POST",
        url: "/GetPaymentMode",
        data: {},
        headers: {
          "Content-Type": "application/json",
          appid: APPID,
          version: VERSION,
          session: AuthInfoObj().session,
          sessionID: AuthInfoObj().sessionID,
          userID: AuthInfoObj().userID,
          loginTypeID: 1,
        },
      });

      if (res?.statuscode === 1) {
        setGetPaymentModeData(res.data.operators || []);
        setShowPopup(false);
        setAddMoneyPopup(true);
      } else {
        console.error(res?.msg);
      }
    } catch (error) {
      console.error("Error in rechargeDiscountOffer:", error);
    }
  };

  const handleClickGateway = (id, remainamt) => {
    getPGDetail(id, remainamt);
  };

  const getPGDetail = async (id, remainamt) => {
    try {
      const res = await ApiCalling.apiClient.request({
        method: "POST",
        url: "/GetPGDetail",
        data: {
          id: id,
          a: remainamt.toString(),
          w: 1,
          vpa: "",
        },
        headers: {
          "Content-Type": "application/json",
          AppID: APPID,
          Version: VERSION,
          Session: AuthInfoObj().session,
          SessionID: AuthInfoObj().sessionID,
          UserID: AuthInfoObj().userID,
          Referer: REFERER,
        },
      });

      if (res?.statuscode === 1) {
        const data = res?.pGModelForWeb;

        switch (data?.pgType) {
          case PG_TYPES.PAYTMJS:
            setPaymentGatewayData({
              type: "paytm",
              paytmJSRequest: data?.paytmJSRequest,
            });
            break;

          case PG_TYPES.RZRPAY:
            setPaymentGatewayData({
              type: "razorpay",
              razorData: data,
            });
            break;

          case PG_TYPES.CASHFREE:
          case PG_TYPES.CASHFREEDEMOTEST:
            setPaymentGatewayData({
              type: "cashfree",
              cashfreeData: data,
            });
            break;

          case PG_TYPES.PHONEPE:
            setPaymentGatewayData({
              type: "phonepe",
              phonepeData: data,
            });
            break;

          default:
            alert("Unsupported or unhandled payment gateway: " + data?.pgType);
            break;
        }
        setAddMoneyPopup(false);
      } else {
        console.error(res?.msg);
      }
    } catch (error) {
      console.error("Error in getPGDetail:", error);
    }
  };

  const handlePrint = () => {
    window.print();
  };

  const closeRechargePopup = () => {
    setShowPopup(false);

    // form reset
    setInput({ Mobile: "" });
    setSelectedAmount("");
    setOID(null);
    setAmountError("");

    setHlrLookupData({
      operator: "",
      circle: "",
      oid: "",
      circleID: "",
    });
  };

  const closeSuccessPopup = () => {
    setSuccessPopup(false);

    // form reset
    setInput({ Mobile: "" });
    setSelectedAmount("");
    setOID(null);
    setAmountError("");

    setHlrLookupData({
      operator: "",
      circle: "",
      oid: "",
      circleID: "",
    });
  };

  const closeAddMoneyPopup = () => {
    setAddMoneyPopup(false);

    setInput({ Mobile: "" });
    setSelectedAmount("");
    setOID(null);
    setAmountError("");

    setHlrLookupData({
      operator: "",
      circle: "",
      oid: "",
      circleID: "",
    });
  };

  return {
    handleChange,
    input,
    getHlrLookupData,
    getRechargePlanData,
    selectedAmount,
    setSelectedAmount,
    oid,
    showPopup,
    setShowPopup,
    handleRechargeClick,
    getBalanceData,
    getDiscountAmtData,
    paymentTransaction,
    setSuccessPopup,
    getPaymentTransaction,
    successPopup,
    getTransactionStatus,
    getPaymentModeData,
    getPaymentMode,
    addMoneyPopup,
    setAddMoneyPopup,
    handleClickGateway,
    paymentGatewayData,
    searchTerm,
    setSearchTerm,
    getBalanceUser,
    rechargeDiscountOffer,
    setInput,
    amountError,
    setOID,
    isRechargeProcess,
    handlePrint,
    closeRechargePopup,
    closeSuccessPopup,
    closeAddMoneyPopup,
    getFilteredList,
  };
};

export default MobilePrepaidService;
